import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import { useSnackbar } from 'notistack';
import { Paper, Button, Grid, TextField, } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import EditIcon from '@material-ui/icons/Edit';
import { getPermissionKey } from "..";
import { checkApiStatus, checkPermission, } from '../../utils_v2';
import { globalGetService, globalPutService } from '../../../globalServices';
import { PageLoader, STableLoader } from '../../shared_elements';
import { assetTypeValues, } from '../../../constants';
import { trackActivity } from '../../../utils/mixpanel';
import { regexConstants } from '../../../constants/regEx';
import { mtInstance } from '../../../shared/components';

const AircraftFuel = ({ params, assetInfoData }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [isEdit, setEdit] = useState(false);
    const [fuelDetails, setFuelDetails] = useState({fuel_capacity_density :null});
    const [error, setError] = useState({});
    useEffect(() => {getFuelDetails('skeletonLoader');}, []);
    const getFuelDetails = (loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(`console/v2/asset/${params.type}/${params.aircraft_slug}/fuel_config_details/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    setFuelDetails(response.data.data);
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
            })
    }
    const onFieldChange = (key, value) => {setFuelDetails({ ...fuelDetails, [key]: value });}
    const onEditFuelDetails = () => {
        let validationInputs = {
            fuel_capacity_density:
              fuelDetails?.fuel_capacity_density === null ||  fuelDetails?.fuel_capacity_density === "" ? "":
              (Number(fuelDetails.fuel_capacity_density) < 0.780 ||
               Number(fuelDetails.fuel_capacity_density) > 0.840)
                ? 'Fuel capacity density must be between 0.780 and 0.840'
                : ""
          };
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true);
            let payload = Object.assign({}, fuelDetails)
            payload = {
                ...payload,
                fuel_capacity_density : fuelDetails?.fuel_capacity_density ? Number(fuelDetails?.fuel_capacity_density ) :null
            }
            globalPutService(`console/v2/asset/${params.type}/${params.aircraft_slug}/fuel_config_details/`, payload)
                .then(response => {
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                        trackActivity('Console Management', { page_title: 'Aircraft Aquisition & Other Details', asset_type: assetTypeValues[assetInfoData?.asset_type.type].label, asset_name: assetInfoData?.serial_number, event_type: 'Item Edited', event_desc: 'Edited Aircraft Aquisition & Other Details data from Edit Aircraft Aquisition & Other Details form' });
                        setEdit(false);
                    }
                    setLoading(false);
                })
        } else {
            setError(validationInputs)
        }
    }
    return (
        <div style={{ position: 'relative' }}>
            <div className="console-forms-fields" style={{ height: `${window.innerHeight - (isEdit ? 260 : 215)}px`, padding: '10px', overflow: 'auto' }}>
                <p style={{ textAlign: 'right', height: '20px' }}>
                    {checkPermission('technical_specs', getPermissionKey(params.type), 'U') && !isEdit ?
                        <span style={{ cursor: 'pointer' }}>
                            <EditIcon onClick={() => { setEdit(true); }} fontSize="small" color='primary' />
                        </span> : null
                    }
                </p>
                {skeletonLoader ? < STableLoader count={3} /> : <>
                    <Grid container spacing={1}>
                        <Grid item md={4}>
                            <TextField
                                disabled={!isEdit}
                                name='fuel_capacity'
                                label='Fuel Capacity (Ltr)'
                                value={fuelDetails?.fuel_capacity || ''}
                                fullWidth
                                margin="normal"
                                inputProps={{ maxLength: 10 }}
                                onChange={(e) => regexConstants.decimalnodotstart.test(e.target.value) ? onFieldChange('fuel_capacity', e.target.value) : e.preventDefault()}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={4}>
                            <TextField
                                disabled={!isEdit}
                                name='fuel_capacity_gal'
                                label='Fuel Capacity (US Gal)'
                                value={fuelDetails?.fuel_capacity_gal || ''}
                                fullWidth
                                margin="normal"
                                inputProps={{ maxLength: 10 }}
                                onChange={(e) => regexConstants.decimalnodotstart.test(e.target.value) ? onFieldChange('fuel_capacity_gal', e.target.value) : e.preventDefault()}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={4}>
                            <TextField
                                disabled={!isEdit}
                                name='ftis'
                                label='Fuel Tank Inerting System'
                                value={fuelDetails?.ftis || ''}
                                fullWidth
                                margin="normal"
                                inputProps={{ maxLength: 50 }}
                                onChange={(e) => onFieldChange('ftis', e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={4}>
                            <TextField
                                disabled={!isEdit}
                                name='fuel_capacity_density'
                                label='Fuel Density'
                                value={fuelDetails?.fuel_capacity_density || ''}
                                fullWidth
                                onFocus={() => setError({...error, 'fuel_capacity_density':''})}
                                inputProps={{ maxLength: 10 }}
                                margin="normal"
                                onChange={(e) => regexConstants.decimalnodotstart3.test(e.target.value) ? onFieldChange('fuel_capacity_density', e.target.value) : e.preventDefault()}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                                error={error?.fuel_capacity_density}
                                helperText={error?.fuel_capacity_density||''}
                            />
                        </Grid>
                        <Grid item md={4}>
                            <TextField
                                disabled={!isEdit}
                                name='additional_center_tanks'
                                label='Additional Center Tanks'
                                value={fuelDetails?.additional_center_tanks || ''}
                                fullWidth
                                margin="normal"
                                inputProps={{ maxLength:  25 }}
                                onChange={(e) => onFieldChange('additional_center_tanks', e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={4}>
                            {(() => {
                                let options = ['Kilograms', 'Pounds'];
                                return (
                                    <Autocomplete
                                        disabled={!isEdit}
                                        options={options}
                                        getOptionLabel={option => option}
                                        name="cockpit_fuel_indication"
                                        value={fuelDetails?.cockpit_fuel_indication || ''}
                                        onChange={(e, value) => { onFieldChange('cockpit_fuel_indication', value); }}
                                        renderInput={params => <TextField {...params} label="Cockpit Fuel Indications" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                    />
                                )
                            })()}
                        </Grid>
                    </Grid>
                </>}
            </div>
            {isEdit ?
                <Paper square style={{ padding: '10px', borderTop: '1px solid #d7d7d7' }}>
                    <ul className="list-inline">
                        <li className="list-inline-item">
                            <Button onClick={() => { setError(''); setEdit(false); getFuelDetails() }} color="primary" size='small' variant="outlined">Cancel</Button>
                        </li>
                        <li className="list-inline-item">
                            <Button onClick={onEditFuelDetails} color="primary" size='small' variant="contained">SAVE</Button>
                        </li>
                    </ul>
                </Paper> : null
            }
            {isLoading ? <PageLoader /> : null}
        </div>
    )
}
export default withRouter(AircraftFuel);